import {
    Button,
    Badge,
    Typography
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useInput, useRecordContext, useResourceContext } from "ra-core";
import FilePreview from "./FilePreview";
import { FileInputModal, FileInputModalProps } from "./FileInputModal";
import { CommonInputProps, InputHelperText, Labeled } from "react-admin";
import { FormHelperText } from "@mui/material";

export type FileInputProps = CommonInputProps & {
    multiple?: boolean;
    fileTypes?: string[];
    path?: string;
    inputType?: "file" | "image" | "document";
    preview?: boolean;
    previewWidth?: string;
    label?: string;
    includeDomain?: boolean;
    lockPath?: boolean;
    required?: boolean;
};

export const FileInput = (props: FileInputProps) => {
    const { 
        source, 
        defaultValue,
        fileTypes=["JPG", "JPEG", "PNG", "GIF", "WEBP", "PDF", "XLS", "XLSX", "DOCX"],
        multiple=true,
        path = "admin/media",
        inputType = "image",
        preview = true,
        previewWidth = "100%",
        label,
        includeDomain = false,
        lockPath = false,
        required,
        validate,
        fullWidth,
        helperText
    } = props;

    const resource = useResourceContext(props);

    const { id, field, fieldState, formState: { isSubmitted }} = useInput({ ...props, source, defaultValue, validate });
    const { error, invalid, isTouched } = fieldState;

    const record = useRecordContext();
    const [paths, setPaths] = useState<string[]>([]);

    const fileInputModalRef = useRef<any>();
    
    const modalProps:FileInputModalProps =  {
        multiple:multiple,
        path: path,
        fileTypes:fileTypes,
        paths: paths,
        setPaths: setPaths,
        includeDomain: includeDomain,
        lockPath: lockPath
    }

    const openModal = () => {
        const currentRef = fileInputModalRef.current;
        if (currentRef) {
            currentRef.handleOpen()
        }
    };

    useEffect(() => {
        setPaths(typeof record !== 'undefined' && typeof record[source] !== 'undefined' &&  record[source] !== null ? record[source].split(", ") :  []);
    }, [record]);

    useEffect(() => {
        field.onChange(paths.length > 0 ? paths.join(", "): "")
    }, [paths]);

    const getButtonText = () =>
        `${paths && paths.length ? "Change" : "Add"} ${inputType}${multiple ? "s" : ""
        }`;

    return (
        <Labeled
            isRequired={required}
            label={label}
            id={`${id}-label`}
            color={fieldState?.invalid ? "error" : undefined}
            source={source}
            resource={resource}
            fullWidth={true}
            sx={{
            ".RaLabeled-label": {
                marginLeft: "14px",
            },
            }}
        >
            <>
                <FileInputModal ref={fileInputModalRef} {...modalProps}></FileInputModal>

                {preview ? <FilePreview paths={paths} setPaths={setPaths} width={previewWidth}/> : null}
                <div>
                <Badge color="primary" badgeContent={paths.length} overlap="rectangular" sx={{marginBottom: "24px"}}>
                    <Button variant="outlined" onClick={openModal}>
                        {getButtonText()}
                    </Button>
                </Badge>
                </div>
                <FormHelperText
                    sx={{width: "100%", marginTop: "14px", paddingLeft: "14px"}}
                    className={
                        (isTouched || isSubmitted) && invalid
                        ? "tinymce-content-input-error"
                        : ""
                    }
                    error={(isTouched || isSubmitted) && invalid}
                >
                    <InputHelperText
                        touched={isTouched || isSubmitted}
                        error={error?.message}
                        helperText={helperText}
                    />
                </FormHelperText>
            </>
        </Labeled>
    );
};

